import React from 'react';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const StepNavigation = ({ 
  currentStep, 
  totalSteps, 
  onNext, 
  onPrevious, 
  onSaveDraft,
  isNextDisabled = false,
  isSubmitting = false,
  showSaveDraft = true
}) => {
  const isFirstStep = currentStep === 0;
  const isLastStep = currentStep === totalSteps - 1;

  return (
    <div className="flex items-center justify-between pt-8 border-t border-border">
      {/* Previous Button */}
      <div>
        {!isFirstStep && (
          <Button
            variant="outline"
            onClick={onPrevious}
            disabled={isSubmitting}
          >
            <Icon name="ChevronLeft" size={16} className="mr-2" />
            Previous
          </Button>
        )}
      </div>

      {/* Save Draft Button */}
      <div>
        {showSaveDraft && !isLastStep && (
          <Button
            variant="ghost"
            onClick={onSaveDraft}
            disabled={isSubmitting}
            className="text-muted-foreground hover:text-foreground"
          >
            <Icon name="Save" size={16} className="mr-2" />
            Save Draft
          </Button>
        )}
      </div>

      {/* Next/Submit Button */}
      <div>
        <Button
          onClick={onNext}
          disabled={isNextDisabled || isSubmitting}
          loading={isSubmitting && isLastStep}
        >
          {isLastStep ? (
            <>
              <Icon name="Send" size={16} className="mr-2" />
              Submit RFQ
            </>
          ) : (
            <>
              Next
              <Icon name="ChevronRight" size={16} className="ml-2" />
            </>
          )}
        </Button>
      </div>
    </div>
  );
};

export default StepNavigation;